const ARRAY_SEPARATOR = ','

export const PROPERTY_FILTER_QUERY_MAP = Object.freeze({
  search: { routeKey: 'search', apiKey: 'search', type: 'string' },
  bookingType: { routeKey: 'bookingType', apiKey: 'bookingType', type: 'string' },
  types: { routeKey: 'types', apiKey: 'types', type: 'list' },
  categories: { routeKey: 'categories', apiKey: 'categories', type: 'list' },
  cities: { routeKey: 'cities', apiKey: 'cities', type: 'list' },
  areas: { routeKey: 'areas', apiKey: 'areas', type: 'list' },
  sharingTypes: { routeKey: 'sharingTypes', apiKey: 'sharingTypes', type: 'list' },
  roomTypePlans: { routeKey: 'roomTypePlans', apiKey: 'roomTypePlans', type: 'list' },
  min: { routeKey: 'min', apiKey: 'min', type: 'number' },
  max: { routeKey: 'max', apiKey: 'max', type: 'number' },
  sort: { routeKey: 'sort', apiKey: 'sort', type: 'string' },
  page: { routeKey: 'page', apiKey: 'page', type: 'number' },
  perPage: { routeKey: 'perPage', apiKey: 'perPage', type: 'number' }
})

export const LEGACY_ROUTE_FILTER_ALIASES = Object.freeze({
  types: ['gender'],
  areas: ['locality']
})

export const serializeFilterList = (values = []) => {
  if (!Array.isArray(values)) {
    return ''
  }

  const normalized = [...new Set(
    values
      .map((value) => String(value ?? '').trim())
      .filter(Boolean)
  )]

  return normalized.join(ARRAY_SEPARATOR)
}

export const parseFilterList = (value) => {
  const single = Array.isArray(value) ? value[0] : value
  if (typeof single !== 'string') {
    return []
  }

  return [...new Set(
    single
      .split(ARRAY_SEPARATOR)
      .map((item) => item.trim())
      .filter(Boolean)
  )]
}
